<p-toast />
<div id="search-throttle-settings" data-cy="search-throttle-settings">
    <h1>Search Throttle Settings</h1>
    <p-card styleClass="mb-4">
        <form>
            <p-table
                id="searchThrottleTable"
                styleClass="rc-datatable-outlined" >
                
                <ng-template pTemplate="header">
                    <tr>
                        <th>Status</th>
                        <th>Module</th>
                        <th>Limit</th>
                        <th>Message</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body">
                    <tr>
                        <td>
                            <p-toggleButton 
                                name="status" 
                                onLabel="Active" 
                                offLabel="Inactive" 
                                onIcon="pi pi-check-circle"
                                offIcon="pi pi-ban" 
                                formControlName="status" />
                        </td>
                        <td>
                            <b class="h4">Expenses</b>
                        </td>
                        <td>
                            <input id="expenseLimit" type="text" pInputText formControlName="expenseLimit" value="10000" />
                        </td>
                        <td>
                            <textarea id="expenseMessage" rows="5" pInputTextarea class="w-full">You reached the max number of records to be retrieved from Vortex. Please narrow down your search.</textarea>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p-toggleButton 
                                name="status" 
                                onLabel="Active" 
                                offLabel="Inactive" 
                                onIcon="pi pi-check-circle"
                                offIcon="pi pi-ban" 
                                formControlName="status" />
                        </td>
                        <td>
                            <b class="h4">Donations</b>
                        </td>
                        <td>
                            <input id="expenseLimit" type="text" pInputText formControlName="expenseLimit" value="10000" />
                        </td>
                        <td>
                            <textarea id="expenseMessage" rows="5" pInputTextarea class="w-full">You reached the max number of records to be retrieved from Vortex. Please narrow down your search.</textarea>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p-toggleButton 
                                name="status" 
                                onLabel="Active" 
                                offLabel="Inactive" 
                                onIcon="pi pi-check-circle"
                                offIcon="pi pi-ban" 
                                formControlName="status" />
                        </td>
                        <td>
                            <b class="h4">Reports</b>
                        </td>
                        <td>
                            <input id="expenseLimit" type="text" pInputText formControlName="expenseLimit" value="10000" />
                        </td>
                        <td>
                            <textarea id="expenseMessage" rows="5" pInputTextarea class="w-full">You reached the max number of records to be retrieved from Vortex. Please narrow down your search.</textarea>
                        </td>
                    </tr>
                </ng-template>
            </p-table>

        </form>
    </p-card>
</div>